import React from "react";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";

// Animated SVG score ring — illustrative Archedia evaluation index.
export const ScoreRing = ({ value = 0, size = 120, stroke = 8, label, sublabel }) => {
  const { theme } = useApp();
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const trackColor = theme === "dark" ? "#2A4F42" : "#E3E4E2";
  const offset = c - (value / 100) * c;

  return (
    <div className="flex flex-col items-center" data-testid="score-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={trackColor} strokeWidth={stroke} />
          <defs>
            <linearGradient id={`ring-grad-${label || "d"}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#9ED3B8" />
              <stop offset="100%" stopColor="#0F4A36" />
            </linearGradient>
          </defs>
          <motion.circle
            cx={size / 2} cy={size / 2} r={r} fill="none"
            stroke={`url(#ring-grad-${label || "d"})`} strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={c}
            initial={{ strokeDashoffset: c }}
            whileInView={{ strokeDashoffset: offset }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <motion.span
            className="font-serif text-3xl font-light text-[var(--text-primary)]"
            initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.5 }}
          >
            {Math.round(value)}
          </motion.span>
          {sublabel && <span className="text-[10px] uppercase tracking-widest text-[var(--text-muted)]">{sublabel}</span>}
        </div>
      </div>
      {label && <span className="mt-3 text-center text-sm font-medium text-[var(--text-primary)]">{label}</span>}
    </div>
  );
};

export default ScoreRing;
